<template>
  <q-card class="my-card">
    <q-card-section>
      <div class="text-center q-mb-sm">
        <div class="text-bold">{{ titleMain }}</div>
        <div class="text-bold">{{ titleSub }}</div>
      </div>
      <div v-if="mainValue !== null" class="text-center text-bold">
        <span :class="mainValueClass" v-if="showMainValueSign && !isMinusValue">+</span>
        <span :class="`text-h4 ${mainValueClass}`" v-if="!isMinusValue">{{ mainValue }}</span>
        <span :class="mainValueClass" v-if="!isMinusValue">{{ mainValueUnit }}</span>
        <span :class="mainValueClass" v-if="showMainValueSign && isMinusValue">-</span>
        <span :class="`text-h4 ${mainValueClass}`" v-if="isMinusValue">{{ mainValue }}</span>
        <span :class="mainValueClass" v-if="isMinusValue">{{ mainValueUnit }}</span>
      </div>
      <div v-if="showProgressBar" class="q-mb-sm">
        <q-linear-progress :value="progressValue" :color="progressColor" size="md" />
      </div>
      <div v-for="(info, index) in additionalInfo" :key="index" class="d-flex justify-end items-center">
        <span class="text-bold" style="text-align: right;">{{ info.label }}:</span>
        <span :class="`text-bold ${info.valueClass}`" style="text-align: left; flex: 1; margin-left: 8px;">{{
          info.value
        }}</span>
      </div>
      <div v-if="showActionButton" class="q-mt-sm">
        <q-btn no-caps class="btn-save full-width" size="sm" :label="actionButtonLabel" @click="onActionClick" />
      </div>
    </q-card-section>
  </q-card>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component'
import { Prop, Emit } from 'vue-property-decorator'

interface AdditionalInfo {
  label: string
  value: string | number
  valueClass?: string
}

@Options({
  name: 'OverviewCard',
})
export default class OverviewCard extends Vue {
  @Prop({ required: true })
  titleMain!: string

  @Prop({ default: '' })
  titleSub!: string

  @Prop({ default: null })
  mainValue!: number | null

  @Prop({ default: '' })
  mainValueUnit!: string

  @Prop({ default: 'text-positive' })
  mainValueClass!: string

  @Prop({ default: false })
  isMinusValue!: boolean

  @Prop({ default: true })
  showMainValueSign!: boolean

  @Prop({ default: () => [] })
  additionalInfo!: AdditionalInfo[]

  @Prop({ default: false })
  showActionButton!: boolean

  @Prop({ default: 'Details' })
  actionButtonLabel!: string

  @Prop({ default: false })
  showProgressBar!: boolean

  @Prop({ default: 0 })
  progressValue!: number

  @Prop({ default: 'positive' })
  progressColor!: string

  @Emit('action-click')
  onActionClick() {
    return {}
  }
}
</script>
